"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Calendar = _interopRequireDefault(require("./Calendar"));
var _Button = _interopRequireDefault(require("../Button"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DatePicker = function DatePicker(_ref) {
  var _ref$nextAvailableDat = _ref.nextAvailableDate,
    nextAvailableDate = _ref$nextAvailableDat === void 0 ? (0, _utils.getDateISO)(new Date()) : _ref$nextAvailableDat,
    onConfirm = _ref.onConfirm,
    _ref$enableDatesInPas = _ref.enableDatesInPast,
    enableDatesInPast = _ref$enableDatesInPas === void 0 ? true : _ref$enableDatesInPas;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    date = _useState2[0],
    setDate = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDateConfirmed = _useState4[0],
    setIsDateConfirmed = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    mounted = _useState6[0],
    setMounted = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dateSelected = _useState8[0],
    setDateSelected = _useState8[1];
  (0, _react.useEffect)(function () {
    if (!mounted) {
      // do componentDidMount logic - make nextAvailableDate automatically selected
      setMounted(true);
      if (typeof nextAvailableDate !== "string") return;

      // if the last item in the string is 4 characters long (YYYY) convert DD-MM-YYYY to YYYY-MM-DD
      if (nextAvailableDate.split("-")[2].length === 4) {
        nextAvailableDate = (0, _utils.reverseDateFormat)(nextAvailableDate);
      }
      var newDate = (0, _utils.isDate)(new Date(nextAvailableDate)) ? new Date(nextAvailableDate) : "";
      newDate && setDate((0, _utils.getDateISO)(newDate));
    } else {
      // do componentDidUpdate logic
      if (date !== nextAvailableDate) {
        setDate(nextAvailableDate);
        setIsDateConfirmed(false);
      }
    }
  }, [mounted]);
  var handleDateChange = function handleDateChange(selectedDateStr) {
    var selectedDate = new Date(selectedDateStr);
    var dateISO = (0, _utils.getDateISO)(selectedDate);
    dateISO && setDate(dateISO);
  };
  var handleConfirm = function handleConfirm() {
    if (!date) return null;
    var parsedDate = date ? (0, _utils.reverseDateFormat)(date) : "";
    setIsDateConfirmed(true);
    setDateSelected(true);
    return onConfirm(parsedDate);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker"
  }, /*#__PURE__*/_react.default.createElement(_Calendar.default, {
    data: date,
    onDateChanged: handleDateChange,
    enableDatesInPast: enableDatesInPast
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "confirm-button",
    type: "button",
    onClick: handleConfirm,
    "data-is-confirmed": isDateConfirmed,
    disabled: dateSelected
  }, "Continue"));
};
var _default = DatePicker;
exports.default = _default;